import { Badge, BadgeBaseProps } from '@twilio-paste/core/badge';
import { Box } from '@twilio-paste/core/box';

interface TableStatusProps extends Pick<BadgeBaseProps, 'variant'> {
  status: string;
}

export function TableStatus({ variant, status }: TableStatusProps) {
  return (
    <Box display="flex" justifyContent="center">
      <Badge as="span" variant={variant}>
        {status}
      </Badge>
    </Box>
  );
}
